import { useContext, createContext as createReactContext } from "react";

const AppAuthContext = createReactContext(false);
AppAuthContext.displayName = "AppAuthContext";

export const { Provider: AppAuthProvider, Consumer: AppAuthConsumer } =
  AppAuthContext;

export function useAuthContext() {
  return useContext(AppAuthContext);
}
